import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist } from 'zustand/middleware';

interface Phase2ReportState {
    stntId: string | null;
    aidx: number | null;
    nickname?: string | null;
    textbkId: number | null;
    publishType: number; // 1: 클래스, 2: url, 3: 출력용
    title: string;
    selectedPersistStntId: string | null;
    isSubmAt: boolean;
    claId: string | null;
    stntSaveSearch?: string | null;
    setStntId: (stntId: string | null) => void;
    setAidx: (aidx: number | null) => void;
    setNickname: (nickname: string | null) => void;
    setTextbkId: (textbkId: number | null) => void;
    setPublishType: (publishType: number) => void;
    setTitle: (title: string) => void;
    setGoToPhase2Report: (
        stntId: string | null,
        nickname: string | null,
        textbkId: number | null,
        publishType: number
    ) => void;
    setSelectedPersistStntId: (selectedPersistStntId: string | null) => void;
    setIsSubmAt: (isSubmAt: boolean) => void;
    setClaId: (claId: string | null) => void;
    reset: () => void;
    setStntSaveSearch: (stntSaveSearch: string | null) => void;
}

export const usePhase2ReportStore = create<Phase2ReportState>()(
    persist(
        immer((set) => ({
            stntId: null,
            aidx: null,
            nickname: null,
            textbkId: null,
            publishType: 1,
            title: '',
            selectedPersistStntId: null,
            isSubmAt: true,
            claId: null,
            setStntId: (stntId) => {
                set((state) => {
                    state.stntId = stntId;
                });
            },
            setAidx: (aidx) => {
                set((state) => {
                    state.aidx = aidx;
                });
            },

            setNickname: (nickname) => {
                set((state) => {
                    state.nickname = nickname;
                });
            },
            setTextbkId: (textbkId) => {
                set((state) => {
                    state.textbkId = textbkId;
                });
            },
            setPublishType: (publishType) => {
                set((state) => {
                    state.publishType = publishType;
                });
            },
            setTitle: (title) => {
                set((state) => {
                    state.title = title;
                });
            },
            setGoToPhase2Report: (stntId, nickname, textbkId, publishType) => {
                set((state) => {
                    state.stntId = stntId;
                    state.nickname = nickname;
                    state.textbkId = textbkId;
                    state.publishType = publishType;
                });
            },

            setSelectedPersistStntId: (selectedPersistStntId) => {
                set((state) => {
                    state.selectedPersistStntId = selectedPersistStntId;
                });
            },

            setIsSubmAt: (isSubmAt) => {
                set((state) => {
                    state.isSubmAt = isSubmAt;
                });
            },

            setClaId: (claId) => {
                set((state) => {
                    state.claId = claId;
                });
            },

            setStntSaveSearch: (stntSaveSearch) => {
                set((state) => {
                    state.stntSaveSearch = stntSaveSearch;
                });
            },

            reset: () =>
                set((state) => {
                    state.stntId = null;
                    state.aidx = null;
                    state.textbkId = null;
                    state.publishType = 1;
                }),
        })),
        {
            name: 'report-storage', // 로컬 스토리지에 저장될 key
            partialize: (state) => ({
                title: state.title,
                stntId: state.stntId,
                nickname: state.nickname,
                aidx: state.aidx,
                textbkId: state.textbkId,
                publishType: state.publishType,
                selectedPersistStntId: state.selectedPersistStntId,
                claId: state.claId,
                stntSaveSearch: state.stntSaveSearch,
            }),
        }
    )
);
